import React, { useState } from 'react';
import Hero from "../../common/Hero";
import Footer from '../../common/Footer';
import FaqImage from '../../assests/images/dcColony.jpg';
import Navbar from "../../common/Navbar";

const faqs = [
  {
    question: 'What types of blinds do you supply and install?',
    answer:
      'MF Carpet and Blinds offers a wide range of made-to-measure blinds including roller, Venetian, vertical, Roman, and zebra blinds. Each blind is custom-fitted to suit your window size and style, ensuring perfect light control and a seamless look in any room.'
  },
  {
    question: 'Do you provide free measuring and installation services?',
    answer:
      'Yes. We offer a free in-home consultation and measurement service. Our experienced fitters take precise measurements, provide professional advice, and ensure your blinds or carpets are installed with care and accuracy for a flawless finish.'
  },
  {
    question: 'Can you repair or clean existing blinds and carpets?',
    answer:
      'Absolutely. We provide minor repair services such as fixing cords, replacing damaged slats, or re-aligning tracks for blinds. For carpets, we offer deep steam cleaning, stain removal, and stretching to remove ripples or wrinkles.'
  },
  {
    question: 'What carpet services do you offer?',
    answer:
      'We supply and install a wide range of carpets — from luxurious plush styles to durable, stain-resistant options. Our services include old carpet removal, underlay installation, floor preparation, and professional fitting by our expert team.'
  },
  {
    question: 'Do you remove and dispose of old flooring?',
    answer:
      'Yes, we take care of everything. Our installers will safely remove and dispose of your old carpet, vinyl, or blinds, and prepare the subfloor or window area before installing your new products.'
  },
  {
    question: 'How do I choose the right carpet or blind for my space?',
    answer:
      'Our team can guide you based on your lifestyle, design preferences, and budget. For high-traffic areas, we recommend durable carpets like nylon or solution-dyed polyester. For blinds, blackout options are ideal for bedrooms, while lighter fabrics suit living spaces.'
  },
  {
    question: 'What are your pricing, lead times, and warranties?',
    answer:
      'Our quotes are free and transparent. Standard installations are usually completed within a week, while custom orders may take 2–4 weeks. All installations come with a workmanship warranty, and manufacturer warranties apply to all products supplied.'
  }
];

const FAQItem = ({ faq, index, isOpen, toggleOpen }) => {
  return (
    <div
      className={`border ${isOpen ? 'border-red-500 shadow-md' : 'border-gray-300'} rounded-xl mb-6 transition-all duration-300`}
    >
      <div
        className="flex justify-between items-center px-6 py-4 cursor-pointer hover:bg-gray-100 transition-colors rounded-t-xl"
        onClick={() => toggleOpen(index)}
      >
        <h2 className="text-lg md:text-xl font-semibold text-gray-800">{faq.question}</h2>
        <div className="transform transition-transform">
          {isOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-red-500" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M18.364 5.636l-1.414-1.414L12 9.172 7.05 4.222l-1.414 1.414L10.828 12l-5.192 5.192 1.414 1.414L12 14.828l4.95 4.95 1.414-1.414L13.172 12z"
              />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 24 24">
              <path fill="currentColor" d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z" />
            </svg>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="px-6 py-4 bg-gray-50 border-t border-red-500 rounded-b-xl">
          <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
          {faq.image && (
            <figure className="mt-4 text-center">
              <img
                src={faq.image}
                alt="FAQ visual"
                className="rounded-lg shadow-md w-full max-w-md mx-auto"
                loading="lazy"
              />
            </figure>
          )}
        </div>
      )}
    </div>
  );
};

const FAQComponent = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggleOpen = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Navbar />
      <Hero text="FAQ" text1="Services" image={FaqImage} />
      <div className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-12 min-h-screen">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl text-center text-gray-800 font-bold mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">
            Find quick answers to the most common questions about MF Carpet and Blinds’ products and services.
          </p>

          <div>
            {faqs.map((faq, index) => (
              <FAQItem
                key={index}
                faq={faq}
                index={index}
                isOpen={openIndex === index}
                toggleOpen={toggleOpen}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FAQComponent;

